import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const File = (props) => (
  <Icon viewBox="0 0 13 15" {...props}>
    <g>
      <path d="M11 14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5v4.5a.5.5 0 0 0 .5.5H12v7a1 1 0 0 1-1 1zM8 1.996L11.008 5H8V1.996zM13 5L8 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V5z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default File;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/File.js